
var leftMenu = {
    toggle: function () {
        var body = document.getElementsByTagName('body')[0];
        //if (body.classList.contains('sidebar-enable')) {
        if (body.hasAttribute('data-leftbar-compact-mode')) {
            body.removeAttribute('data-leftbar-compact-mode');
            body.classList.remove('sidebar-enable');
        }
        else {
            var mode = body.clientWidth <= 576 ? '' : 'condensed';
            console.log(mode);
            body.setAttribute('data-leftbar-compact-mode', mode);
            body.classList.add('sidebar-enable');
        }
    }
};
